module.exports = __webpack_public_path__ + "static/media/比赛6.416c8f22.png";